
angular.module('bmsApp.directives').factory('EmailSvc', [
	'$q',
	'$rootScope',
	'$modal',
	'notify',
	'CRUDSvc',
	'EMAIL_API', function (
		$q,
		$rootScope,
		$modal,
		notify,
		CRUDSvc,
		EMAIL_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(EMAIL_API.INDEX, params);
		},
		read: function (id, params) {
			return CRUDSvc.get(EMAIL_API.READ + id, params);
		},
		showSendModal: function (email, customer) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/global/email/templates/EmailSendModal.html',
				controller: 'EmailSendModalFormCtrl',
				size: 'lg',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					email: function () {
						return angular.copy(email);
					},
					customer: function () {
						return angular.copy(customer);
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					notify({
						message: 'Email sent successfully'
					});
				}
				else {
					notify({
						message: result.error,
						classes: 'error',
						duration: '0'
					});
				}
			}, function () {
				// closed
			});
		},

		send: function (email) {
			return CRUDSvc.post(EMAIL_API.SEND, email);
		}
	};

}]).constant('EMAIL_API', {
	INDEX: 'api/email/index',
	READ: 'api/email/read/',
	SEND: 'api/email/send'
});
